// <auto-generated />
// ATENCAO: Arquivo auto-gerado pelo SetupController. Nao altere manualmente.

export const ST = {
  Ativo: 'ST1',
  Inativo: 'ST2',
  // Mapa de sequencia (SequenciaLista) para lookup por codigo
  sequencia: {
    ST1: 1,
    ST2: 2
  }
}
